<template>
  <el-dialog
    title="Индикаторы"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
  >
    <div v-loading="loading">
      <el-table :data="indicators" border>
        <el-table-column prop="name" label="Название" width="500"></el-table-column>
        <el-table-column prop="description" label="Описание"></el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "indicators-table-list",
  data() {
    return {
      loading: false,
      indicators: [],
      show: false,
    }
  },
  methods: {
    async open(competence) {
      this.indicators = [];
      this.loadIndicator(competence);
      this.show = true;
    },
    close() {
      this.show = false;
    },
    loadIndicator(competence) {
      this.loading = true;
      this.$api.evaluation.indicatorSearch({
        competence_id: competence.id
      })
        .then(({data}) => {
          this.indicators = data.indicators;
        })
        .finally(() => {
          this.loading = false;
        })
    },
  }
}
</script>

<style>

</style>